import { TTechnologiesValues } from '@enums/common';

export function getTechnologyPartForUrl(technology: TTechnologiesValues): string {
	const technologyType = technology.toString().includes('4G') ? '4g' : '5g';
	const technologyMode = technology.toString().includes('TDD') ? 'tdd' : 'fdd';

	return technologyType === '4g' ? `4g/${technologyMode}` : '5g';
}
